import { Chip, Flex } from '@servicetitan/anvil2';
import { Calculation, PaymentStructure } from '@servicetitan/financing-api-client';
import { core } from '@servicetitan/anvil2/token';
import { plansTag } from './PlansTags.module.scss';

interface PlanTagsProps {
    plan: Calculation;
    showLowestPayment?: boolean;
}

export const PlanTags = ({ plan, showLowestPayment = true }: PlanTagsProps) => {
    const lowestColor = core.primitive.ColorGreen100.value;
    const paymentStructureColor = core.primitive.ColorBlue100.value;

    return (
        <Flex gap="1" wrap="wrap">
            {showLowestPayment && plan.hasLowestPayment && plan.hasLowestRate && (
                <Chip className={plansTag} label="Lowest Payment & APR" color={lowestColor} />
            )}
            {showLowestPayment && plan.hasLowestPayment && !plan.hasLowestRate && (
                <Chip className={plansTag} label="Lowest Payment" color={lowestColor} />
            )}
            {showLowestPayment && !plan.hasLowestPayment && plan.hasLowestRate && (
                <Chip className={plansTag} label="Lowest APR" color={lowestColor} />
            )}
            {plan.paymentStructure === PaymentStructure.Promotional && (
                <Chip className={plansTag} label="Promotional" color={paymentStructureColor} />
            )}
            {plan.paymentStructure === PaymentStructure.NoInterest && (
                <Chip className={plansTag} label="0% APR" color={paymentStructureColor} />
            )}
            {plan.paymentStructure === PaymentStructure.MixedInterest && (
                <Chip className={plansTag} label="Mixed Interest" color={paymentStructureColor} />
            )}
            {(plan.paymentStructure === PaymentStructure.DeferredInterest ||
                plan.paymentStructure === PaymentStructure.DeferredInterestAndPrincipal) && (
                <Chip
                    className={plansTag}
                    label="Deferred Interest"
                    color={paymentStructureColor}
                />
            )}
            {plan.paymentStructure === PaymentStructure.StandardInstallment && (
                <Chip className={plansTag} label="Fixed Rate" color={paymentStructureColor} />
            )}
        </Flex>
    );
};
